import { render, staticRenderFns } from "./Translator.vue?vue&type=template&id=a0c37dac&scoped=true&"
import script from "./Translator.vue?vue&type=script&lang=js&"
export * from "./Translator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c37dac",
  null
  
)

export default component.exports